import React from "react";
import "@/App.css";
import { useMetaPixel } from "@/lib/useMetaPixel";
import TopBar from "@/components/TopBar";
import Hero from "@/components/Hero";
import Diagnostico from "@/components/Diagnostico";
import Diagrama from "@/components/Diagrama";
import Metodo from "@/components/Metodo";
import AntesDespues from "@/components/AntesDespues";
import Comparativa from "@/components/Comparativa";
import Ingredientes from "@/components/Ingredientes";
import Testimonios from "@/components/Testimonios";
import Oferta from "@/components/Oferta";
import NoEsPara from "@/components/NoEsPara";
import Faq from "@/components/Faq";
import { Cierre, Footer } from "@/components/CierreFooter";
import FloatingCTA from "@/components/FloatingCTA";

function App() {
  useMetaPixel();

  return (
    <div className="App" style={{ background: "var(--crema)" }}>
      <TopBar />
      <main>
        <Hero />
        <Diagnostico />
        <Diagrama />
        <Metodo />
        <AntesDespues />
        <Comparativa />
        <Ingredientes />
        <Testimonios />
        <Oferta />
        <NoEsPara />
        <Faq />
        <Cierre />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default App;
